
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools",
      function () {
        return require("private-next-pages/tools/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools"])
      });
    }
  